<template>
  <div class="sf-shipping-details">
    <transition :name="transition">
      {{ editAddress }}
      <SfTabs v-if="editAddress" key="edit-address" :open-tab="1" class="tab-orphan"
        data-testid="shipping-details-tabs">
        <SfTab :title="changeAddressTabTitle">
          <slot name="change-address-description">
            <p class="message">
              {{ changeAddressDescription }}
            </p>
          </slot>
          <div>
            <slot name="form">
              <ValidationObserver v-slot="{ valid }" ref="myShippingForm">
                <form @submit.prevent="updateAddress()" class="form">
                  <ValidationProvider name="country" rules="required|min:2" v-slot="{ errors }" slim>
                    <SfSelect v-if="countries" v-e2e="'shipping-country'" v-model="address.country" :label="selectLabel"
                      name="country" class="form__element form__element--half form__select sf-select--underlined"
                      required :valid="!errors[0]" :errorMessage="$t(errors[0], { min: 2 })"
                      @input="($event) => changeCounry($event)">
                      <SfSelectOption v-for="countryOption in countries" :key="countryOption.key"
                        :value="countryOption.simple_speech">
                        {{ $t(countryOption.simple_speech) }}
                      </SfSelectOption>
                    </SfSelect>
                  </ValidationProvider>
                  <ValidationProvider name="state" rules="required" v-slot="{ errors }" slim>
                    <!-- <SfInput
                      v-model="address.state"
                      name="state"
                      :label="$t(inputsLabels[5])"
                      class="form__element form__element--half form__element--half-even"
                      required
                      :valid="!errors[0]" :errorMessage="$t(errors[0])"
                    /> -->
                    <SfSelect v-e2e="'shipping-state'" v-model="address.state" :label="$t(inputsLabels[5])" name="state"
                      class="form__element form__element--half form__select sf-select--underlined" required
                      :valid="!errors[0]" :errorMessage="$t(errors[0])">
                      <SfSelectOption v-if="provinces" v-for="province in provinces" :key="province.id"
                        :value="province.countries_library_nodes_name">
                        {{ province.countries_library_nodes_name }}
                      </SfSelectOption>
                    </SfSelect>
                  </ValidationProvider>
                  <ValidationProvider v-if="address.country!=='JP'" name="city" rules="required" v-slot="{ errors }"
                    slim>
                    <SfInput v-model="address.city" name="city" :label="$t(inputsLabels[4])" required
                      class="form__element form__element--half" :valid="!errors[0]" :errorMessage="$t(errors[0])" />
                  </ValidationProvider>
                  <ValidationProvider name="streetName" rules="required" v-slot="{ errors }" slim>
                    <SfInput v-model="address.streetName" name="streetName"
                      :label="address.country !== 'JP' ? $t(inputsLabels[2]) : $t('Shipping_details')" required
                      class="form__element" :valid="!errors[0]" :errorMessage="$t(errors[0])" />
                  </ValidationProvider>
                  <ValidationProvider v-if="address.country !== 'JP'" name="apartment" rules="required"
                    v-slot="{ errors }" slim>
                    <SfInput v-model="address.apartment" name="apartment" :label="$t(inputsLabels[3])" required
                      class="form__element" :valid="!errors[0]" :errorMessage="$t(errors[0]) " />
                  </ValidationProvider>
                  <ValidationProvider name="zipCode" rules="required|min:2" v-slot="{ errors }" slim>
                    <SfInput v-model="address.zipCode" name="zipCode" :label="$t(inputsLabels[6])" required
                      :valid="!errors[0]" :errorMessage="$t(errors[0], { min: 2 })" class="form__element" />
                  </ValidationProvider>
                  <ValidationProvider v-if="address.country !== 'JP'" name="firstName" rules="required|min:1"
                    v-slot="{ errors }" slim class="form__element form__element--half">
                    <SfInput v-model="address.firstName" name="firstName" :label="$t(inputsLabels[0])" required
                      class="form__element form__element--half" :valid="!errors[0]"
                      :errorMessage="$t(errors[0], { min: 1 })" />
                  </ValidationProvider>
                  <ValidationProvider name="lastName" rules="required|min:1" v-slot="{ errors }" slim>
                    <SfInput v-model="address.lastName" name="lastName"
                      :label="address.country !== 'JP'? $t(inputsLabels[1]): $t('order_shopping_firstname')" required
                      class="form__element form__element--half "
                      :class="{'form__element--half-even': address.country !== 'JP'}" :valid="!errors[0]"
                      :errorMessage="$t(errors[0], { min: 1 })" />
                  </ValidationProvider>
                  <!-- <ValidationProvider name="country" rules="required|min:2" v-slot="{ errors }" slim>
                    <SfComponentSelect
                      v-model="country"
                      name="country"
                      :label="selectLabel"
                      required
                      :valid="!errors[0]" :errorMessage="$t(errors[0], { min: 2 })"
                      class="sf-component-select--underlined form__select form__element form__element--half"
                      data-testid="country"
                    >
                      <SfComponentSelectOption
                        v-for="countryOption in countries"
                        :key="countryOption.key"
                        :value="countryOption.simple_speech"
                      >
                        {{ countryOption.name }}
                      </SfComponentSelectOption>
                    </SfComponentSelect>
                  </ValidationProvider> -->
                  <ValidationProvider name="phone" rules="required|precision" v-slot="{ errors }" slim>
                    <SfInput v-model="address.phoneNumber" name="phone" :label="$t(inputsLabels[7])" required
                      class="form__element" :valid="!errors[0]" :errorMessage="$t(errors[0])" />
                  </ValidationProvider>
                  <SfButton v-if="updateAddressButtonText" class="action-button" data-testid="update-address-button"
                    type="submit">
                    {{ $t(updateAddressButtonText) }}</SfButton>
                  <SfButton v-if="cancelButtonText" class="action-button color-secondary cancel-button"
                    data-testid="update-address-button" @click="cancelEditing">
                    {{ $t(cancelButtonText) }}</SfButton>
                </form>
              </ValidationObserver>
            </slot>
          </div>
        </SfTab>
      </SfTabs>
      <SfTabs v-else key="address-list" :open-tab="1" class="tab-orphan">
        <SfTab :title="shippingTabTitle">
          <slot name="shipping-tab-description">
            <p class="message">
              {{ shipingTabDescription }}
            </p>
          </slot>
          <transition-group tag="div" :name="transition" class="shipping-list">
            <slot name="shipping-list">
              <div v-for="(shipping, key) in account.shipping" :key="shipping.addressId + shipping.streetName + shipping.apartment
                " class="shipping" data-testid="shipping-address-list-item">
                <div class="shipping__content">
                  <slot name="shipping-details">
                    <p class="shipping__address">
                      <span class="shipping__client-name">
                        {{ shipping.firstName }} {{ shipping.lastName }}
                      </span>
                      <br />
                      {{ shipping.streetName }} {{ shipping.apartment }}
                      <br />
                      {{ shipping.zipCode }}
                      {{ shipping.city }},<br />{{ $t(shipping.country) }}
                    </p>
                    <p class="shipping__address">
                      {{ shipping.phoneNumber }}
                    </p>
                  </slot>
                </div>
                <div class="shipping__actions">
                  <SfButton class="sf-button--pure" @click="deleteAddress(key)">
                    <SfIcon icon="cross" color="gray" size="14px" class="smartphone-only" />
                  </SfButton>
                  <SfButton v-if="changeButtonText" data-testid="change-address" @click="changeAddress(key)">
                    {{ changeButtonText }}
                  </SfButton>
                  <SfButton v-if="deleteButtonText" class="shipping__button-delete desktop-only"
                    data-testid="delete-address" @click="deleteAddress(key)">
                    {{ deleteButtonText }}
                  </SfButton>
                </div>
              </div>
            </slot>
          </transition-group>
          <SfButton v-if="addNewAddressButtonText" class="action-button" data-testid="add-new-address"
            @click="changeAddress(-1)">
            {{ addNewAddressButtonText }}
          </SfButton>
        </SfTab>
      </SfTabs>
    </transition>
  </div>
</template>
<script>
import {
  SfTabs,
  SfInput,
  SfButton,
  SfComponentSelect,
  SfIcon,
  SfSelect
} from '@storefront-ui/vue';
import { required, min } from 'vee-validate/dist/rules';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
extend('required', {
  ...required,
  message: 'Shipping_valid_required'
});
extend('min', {
  ...min,
  message: 'Shipping_valid_length_min'
});
extend('precision', {
  validate: value => {
    const precision = value.toString()?.length || 0;
    return precision >= 6;
  },
  message: 'Shipping_valid_Phone'
});
import { ref } from '@nuxtjs/composition-api';
import { useProvince } from '@bee-hole/coms';
export default {
  name: 'MyShippingDetails',
  components: {
    SfTabs,
    SfInput,
    SfButton,
    SfComponentSelect,
    SfIcon,
    ValidationProvider,
    ValidationObserver,
    SfSelect
  },
  props: {
    shippingTabTitle: {
      type: String,
      default: 'Shipping details'
    },
    changeAddressTabTitle: {
      type: String,
      default: 'Change the address'
    },
    account: {
      type: Object,
      default: () => ({})
    },
    transition: {
      type: String,
      default: 'sf-fade'
    },
    changeAddressDescription: {
      type: String,
      default: ''
    },
    changeButtonText: {
      type: String,
      default: 'Change'
    },
    deleteButtonText: {
      type: String,
      default: 'Delete'
    },
    addNewAddressButtonText: {
      type: String,
      default: 'Add new address'
    },
    updateAddressButtonText: {
      type: String,
      default: 'Update the address'
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel'
    },
    inputsLabels: {
      type: Array,
      default: () => [
        'MyAccount_MyShippingDetails_First',
        'MyAccount_MyShippingDetails_Last',
        'MyAccount_MyShippingDetails_Street',
        'MyAccount_MyShippingDetails_HouseNumber',
        'MyAccount_MyShippingDetails_City',
        'MyAccount_MyShippingDetails_State',
        'MyAccount_MyShippingDetails_Zip',
        'MyAccount_MyShippingDetails_Phone'
      ]
    },
    selectLabel: {
      type: String,
      default: 'Country'
    },
    shipingTabDescription: {
      type: String,
      default: ''
    },
    countries: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // editAddress: false,
      editedAddress: -1,
      addressId: '',
      firstName: '',
      lastName: '',
      streetName: '',
      apartment: '',
      city: '',
      state: '',
      zipCode: '',
      country: '',
      phoneNumber: ''
    };
  },
  methods: {
    // changeAddress(index) {
    //   const account = this.account;
    //   // console.error("地址列表：",account);
    //   const shipping = account.shipping[index];
    //   if (index > -1) {
    //     this.addressId = shipping.addressId;
    //     // this.firstName = account.firstName;
    //     // this.lastName = account.lastName;
    //     this.firstName = shipping.firstName;
    //     this.lastName = shipping.lastName;
    //     this.streetName = shipping.streetName;
    //     this.apartment = shipping.apartment;
    //     this.city = shipping.city;
    //     this.state = shipping.state;
    //     this.zipCode = String(shipping.zipCode);
    //     this.country = shipping.country;
    //     this.phoneNumber = shipping.phoneNumber;
    //     this.sort = shipping.sort;
    //     this.is_default = shipping.is_default;
    //     this.editedAddress = index;
    //   } else {
    //     this.addressId = 0;
    //     this.firstName = '';
    //     this.lastName = '';
    //     this.streetName = '';
    //     this.apartment = '';
    //     this.city = '';
    //     this.state = '';
    //     this.zipCode = '';
    //     this.country = '';
    //     this.phoneNumber = '';
    //     this.sort = 0;
    //     this.is_default = 0;
    //     this.editedAddress = index;
    //   }
    //   console.error('addressId:', this.addressId);
    //   this.editAddress = true;
    //   this.$emit('change-address', index);
    //   setTimeout(() => {
    //     if (this.addressId !== 0) {
    //       this.$refs?.myShippingForm?.validate();
    //     }
    //   }, 500);
    // },
    // updateAddress() {
    //   // const account = { ...this.account };
    //   const shipping = {
    //     addressId: this.addressId,
    //     firstName: this.firstName,
    //     lastName: this.lastName,
    //     apartment: this.apartment,
    //     streetName: this.streetName,
    //     city: this.city,
    //     state: this.state,
    //     zipCode: this.zipCode,
    //     country: this.country,
    //     phoneNumber: this.phoneNumber,
    //     sort: 1,
    //     is_default: 1
    //   };

    //   //   const index = this.editedAddress;
    //   //   if (index > -1) {
    //   //     account.shipping[index] = shipping;
    //   //     this.editedAddress = -1;
    //   //   } else {
    //   //     account.shipping.push(shipping);
    //   //   }
    //   // this.editAddress = false;
    //   this.$emit('update:shipping', shipping);
    // },
    // closeEdit() {
    //   this.editAddress = false;
    // },
    // cancelEditing() {
    //   const account = this.account;
    //   this.editAddress = false;
    //   this.$emit('cancel-editing', account);
    // },
    // deleteAddress(index) {
    //   console.error('index', index, this.account);
    //   // return false;
    //   // const account = { ...this.account };
    //   const account = this.account;
    //   this.$emit('delete-address', account.shipping[index]);
    //   account.shipping.splice(index, 1);
    // }
  },
  // 将上面data 和methods转成 setup写法
  setup(props, context) {
    const { result: provinceList, getProvince } = useProvince();
    const editAddress = ref(false);
    const myShippingForm = ref();
    const provinces = ref();
    const address = ref({
      editedAddress: -1,
      addressId: '',
      firstName: '',
      lastName: '',
      streetName: '',
      apartment: '',
      city: '',
      state: '',
      zipCode: '',
      country: '',
      phoneNumber: ''
    });
    const changeCounry = async (value, edit = false) => {
      // address.value.country = value;
      await getProvince({ country_code: value });
      provinces.value = provinceList.value?.list;
      if (!edit) {
        address.value.state = provinces.value[0]?.countries_library_nodes_name;
      }
    };
    const changeAddress = (index) => {
      const account = props.account;
      // console.error("地址列表：",account);
      const shipping = account.shipping[index];
      if (index > -1) {
        address.value.addressId = shipping.addressId;
        // address.value.firstName = account.firstName;
        // address.value.lastName = account.lastName;
        address.value.firstName = shipping.firstName;
        address.value.lastName = shipping.lastName;
        address.value.streetName = shipping.streetName;
        address.value.apartment = shipping.apartment;
        address.value.city = shipping.city;
        address.value.state = shipping.state;
        address.value.zipCode = String(shipping.zipCode);
        address.value.country = shipping.country;
        address.value.phoneNumber = shipping.phoneNumber;
        address.value.sort = shipping.sort;
        address.value.is_default = shipping.is_default;
        address.value.editedAddress = index;
        changeCounry(shipping.country, true);
      } else {
        address.value.addressId = 0;
        address.value.firstName = '';
        address.value.lastName = '';
        address.value.streetName = '';
        address.value.apartment = '';
        address.value.city = '';
        address.value.state = '';
        address.value.zipCode = '';
        address.value.phoneNumber = '';
        address.value.sort = 0;
        address.value.is_default = 0;
        address.value.editedAddress = index;
        address.value.country = props.countries[0]?.simple_speech || '';
        changeCounry(address.value.country, false);
      }
      editAddress.value = true;
      context.emit('change-address', index);
      setTimeout(() => {
        if (address.value.addressId !== 0) {
          myShippingForm.value?.validate();
        }
      }, 500);
    };
    const updateAddress = () => {
      // const account = { ...this.account };
      const shipping = {
        addressId: address.value.addressId,
        firstName: address.value.firstName,
        lastName: address.value.lastName,
        apartment: address.value.apartment,
        streetName: address.value.streetName,
        city: address.value.city,
        state: address.value.state,
        zipCode: address.value.zipCode,
        country: address.value.country,
        phoneNumber: address.value.phoneNumber,
        sort: 1,
        is_default: 1
      };
      context.emit('update:shipping', shipping);
    };
    const closeEdit = () => {
      editAddress.value = false;
    };
    const cancelEditing = () => {
      const account = props.account;
      editAddress.value = false;
      context.emit('cancel-editing', account);
    };
    const deleteAddress = (index) => {
      console.error('index', index, props.account);
      // return false;
      // const account = { ...this.account };
      const account = props.account;
      context.emit('delete-address', account.shipping[index]);
      account.shipping.splice(index, 1);
    };
    return {
      address,
      editAddress,
      changeAddress,
      myShippingForm,
      updateAddress,
      closeEdit,
      cancelEditing,
      deleteAddress,
      changeCounry,
      provinces
    };
  }
};
</script>
<style lang="scss" scoped>
@import '~@storefront-ui/shared/styles/components/templates/SfShippingDetails.scss';
</style>
